import {Component, OnInit} from '@angular/core';
import { UserStore } from 'src/app/modules/authentication/state/user.store';
import { GlobalQuestionService } from 'src/app/modules/shared/services/global-question.service';

@Component({
    selector: 'app-wallet',
    templateUrl: './wallet.component.html',
    styleUrls: ['./wallet.component.scss'],
    standalone: false
})
export class WalletComponent implements OnInit {
 user: any;
 wallets: any = [];
 wallet_ids: any = [];
  constructor(public globalQuestionService: GlobalQuestionService,
    private userStore: UserStore
    ) { 
      this.globalQuestionService.spinner(true);
      this.user = this.userStore.getValue();
    }

  ngOnInit(): void {
    const parameters = new Map<string, string>();
    parameters.set('person_id', this.user?.person_id?.toString());
      this.globalQuestionService.runCommandNew(`getWallet`, parameters)
         .subscribe(wallets => {
           console.log(wallets);
           this.wallets = wallets;
           wallets.forEach(w => {
              if (!this.wallet_ids.includes(w?.wallet_id)){
                this.wallet_ids.push(w.wallet_id)
              }
            });
            console.log(this.wallet_ids)
            this.globalQuestionService.spinner(false);
         });
  }
  getBalance(id: string): string {
    return this.wallets.find( w => w.wallet_id === id && w.entry_type === 'balance')?.transaction_value;
  }

}
